import type { GetFilesListResponseDto } from 'app/API';

type TServerMediaFile = { Id?: unknown; id?: unknown; Name?: unknown; fileName?: unknown };

const isServerMediaFile = (value: unknown): value is TServerMediaFile => typeof value === 'object' && value !== null;

export const findServerMediaFileName = (media: GetFilesListResponseDto['media'], mediaId: string) => {
  const file = media.filter(isServerMediaFile).find((item) => String(item.Id ?? item.id ?? '') === mediaId);
  return String(file?.Name ?? file?.fileName ?? '');
};
